import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
    ImageCropperComponent,
} from 'ngx-image-cropper';

import { ModalRef } from '../../services/modal/modal-ref';
import { ButtonComponent } from '~/app/shared/components/elements/buttons/button/button.component';
import { H2Component } from '~/app/shared/components/elements/h2/h2.component';
import {
    ButtonWithIconComponent
} from "~/app/shared/components/elements/buttons/button-with-icon/button-with-icon.component";
import {LabelComponent} from "~/app/shared/components/elements/label/label.component";

@Component({
    selector: 'eb-modal-image-cropper',
    templateUrl: './modal-image-cropper.component.html',
    styleUrls: ['./modal-image-cropper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        H2Component,
        ImageCropperComponent,
        ButtonComponent,
        TranslocoPipe,
        ButtonWithIconComponent,
        LabelComponent,
    ]
})
export class ModalImageCropperComponent {
    private ref = inject<ModalRef<File | null, {
    file: File;
}>>(ModalRef);

    public readonly cropper = viewChild.required<ImageCropperComponent>('cropper');

    public file: File = this.ref.data.file;

    public close() {
        this.ref.close(null);
    }

    public async confirm() {
        const e = this.cropper().crop('blob');

        if (e === null) {
            return;
        }

        const result = await e;

        if (!result.blob) {
            return;
        }

        const fileBlob: Blob = result.blob;

        const file = new File([fileBlob], 'file.png', { type: 'image/png' });
        this.ref.close(file);
    }
}
